import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Box, Paper, Typography } from '@mui/material';

const InterviewLogManual = () => {
  const { t } = useTranslation();
  return (
    <Paper variant="outlined">
      <Box p={1} textAlign="center">
        <Typography variant="body2">
          {t('hiring-dashboard-interviewers:interviewers.moduleMemberSidepanel.interviewLog.loggedManually')}
        </Typography>
      </Box>
    </Paper>
  );
};

export default InterviewLogManual;
